<template>
 <div id="journal">
    <div v-if="!isBusy && !errored && hasUserAccess">
      
    <b-container fluid>
      <b-row>
        <b-col class="p-0">
          <div style="min-width:400px;">

            <div class="ml-1 border  border-secondary float-left" >
              
              <b-button-toolbar style="min-width:380x;">

              <b-button-group>
              <b-dropdown class="" no-caret variant="light">
                  <template v-slot:button-content>
                    <img alt="calendar" src="@/assets/images/calendar-icon.svg"  height="24px">
                  </template>
                  <b-dropdown-form>

                    <b-calendar :value="calDate" :max="maxDate" hide-header today-variant="danger" label-help="" locale="en-US" @selected="onSelected"></b-calendar>

                  </b-dropdown-form>
                </b-dropdown>  
                </b-button-group>
                
                <b-button-group v-if="date">
                  <b-button class="p-1"  size="sm" variant="light" @click="previous"> &#x25C0; </b-button>  
                  <span class="mx-auto p-2" > <b> {{ date | moment("dddd, MMMM Do YYYY") }} </b> </span> 
                  <b-button class="p-1" size="sm" variant="light" @click="next">  &#x25b6; </b-button>  
                </b-button-group>
                  
              </b-button-toolbar>

            </div>
    
        </div>

        </b-col>
          
      </b-row>

    </b-container>
  
    <div v-if="date"> 
    
      <b-tabs class="mt-1" v-model="tabIndex" active-nav-item-class="font-weight-bold" style="max-width: 760px;" @input="handleTab" >
        <b-tab no-body >
          <template v-slot:title>
            Journal Entry
          </template>
          
          <div v-if="data">
            <div> <JournalPage :data="data" v-if="view=='Journal'" :key="journalId" @photo-view="switchView"></JournalPage> </div>
            <div> <PhotoPage v-if="view=='Photos'" :projectId=journalId :journalDate=date @journal-view="switchView">  </PhotoPage> </div>          
          </div>

        </b-tab>
        
        <b-tab v-if="view!='Photos'" no-body>
          <template v-slot:title>
            <div id="journalview">Journal View </div>
          </template>

            <JournalView id="journalview"  :data="data" :project="journalItem" > </JournalView>

        </b-tab>

      <b-tab v-if="view!='Photos'" no-body>
          <template v-slot:title>
            Journal Photos
          </template>

          <JournalPhotos v-if="tabIndex==2" id="journalPhotos"> </JournalPhotos>

      </b-tab>
        
      </b-tabs>

    </div>
      
 </div>

    <div v-if="!hasUserAccess && !errored && !isBusy" class="text-center pt-3">
      <p class="text-danger">No user access granted to this journal.</p>
    </div>

    <!-- <div v-if="isBusy && !errored"> -->
      <div v-if="isBusy && !errored" class="text-center pt-5">
      <b-spinner label="Loading..."></b-spinner>
    </div>

    <div v-if="errored" class="text-center pt-3">
      <p class="text-danger">An error occurred loading data.</p>
      <p>{{ error }}</p>
      <p>
        <b-button type="button" @click="reload">Reload</b-button>
      </p>
    </div>

  </div>
</template>

<script>

import JournalPage from "@/components/journal/JournalPage.vue";
import PhotoPage from "@/components/journal/PhotoPage.vue";
import JournalView from "@/components/journal/JournalView.vue";
import JournalPhotos from "@/components/journal/JournalPhotos.vue";


export default {
  name: "Journal",
  components: {
    JournalPage,
    PhotoPage,
    JournalView,
    JournalPhotos
  },

  data: function() {
    return {
      data: null,
      state: this.$store.state,
      journalId: this.$route.params.id,
      date: this.$route.params.date,
      tabIndex: 0,
      view: "Journal",
      journalItem: {projectId:"", description:"", isJournal:true},
      modules: [],
      isAdmin: false,
      isBusy: true,
      loading: true,
      loaded: false,
      errored: false,
      error: "",
     
    };
  },

  computed:{
 
    calDate: function(){
      var day = this.$moment(this.date,"YYYYMMDD").format("YYYY-MM-DD");
      return day;
    },
    maxDate: function(){
      return this.$moment().add(7,'days').format("YYYY-MM-DD"); 
    },
    hasUserAccess() {
     const ids = this.state.userJournals.map(journal => journal.id);
     const id = parseInt(this.journalId,10);
     return (ids.includes (id));

    }
    
  },
 
  methods: {
    fetchData() {
      this.$auth.acquireToken().then(token => {
          this.$http.get("api/Journals/" + this.journalId, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(response => {
        
            this.journalItem.projectId = response.data.id.toString();
            this.journalItem.description = response.data.title;
            this.setBreadcrumb();

             if (this.date){
                  this.fetchJournalData();
                }
          })
          .catch(error => {
            this.errored = true;
            this.loaded = false;

            if (error.response) {
              this.error = error.response.statusText;
            };
            if (error.response.status === 404){
                this.error = "Journal " + this.journalId + ": Not found/No access "; 
            };

          })
          .finally(() => (this.isBusy = false));
      });
    },

    fetchJournalData() {

      if (this.hasUserAccess)
       {
        this.$auth.acquireToken().then(token => {
          this.$http.get(
              "api/JournalPage/" + this.journalId + "/" + this.date,
              {
                headers: { Authorization: "Bearer " + token }
              }
            )
            .then(response => {
                this.data = response.data;
                //this.setIsAdmin();
            })
            .catch(error => {
              this.errored = true;
              this.loaded = false;
              if (error.response) {
                this.error = error.response.statusText;
              }
            })
            .finally(() => (this.isBusy = false));
        });    
      }
      
    },

    switchView(){
      if (this.view == 'Journal') {
        this.view = "Photos"
      }
      else{
        this.view = "Journal"
      }

    }, 

    onSelected(date){
        var day = this.$moment(date,"YYYY-MM-DD").format("YYYYMMDD"); 
        this.$router.push({name: 'StandaloneJournal', params: { id: this.journalId, date: day  } }, () =>{} );
    },

    next(){
      var nextDay = this.$moment(this.date,"YYYYMMDD").add(1,'days').format("YYYYMMDD"); 
      this.$router.push({name: 'StandaloneJournal', params: { id: this.journalId, date: nextDay  } }, () =>{} );
      
    },
    previous(){
      var prevDay = this.$moment(this.date,"YYYYMMDD").subtract(1,'days').format("YYYYMMDD"); 
      this.$router.push({name: 'StandaloneJournal', params: { id: this.journalId, date: prevDay  } }, () =>{} );
    },

    reload() {
      this.errored = false;
      this.isBusy = true;
      this.fetchData();
    },
 

    handleTab() {
      //handle tab 2 selected: 
     
    },

    setBreadcrumb() {
      this.$store.setItem("breadcrumbs", [
        {
          text: this.journalId,
        },
        {
          text: this.journalItem.description
        }
      ]);
    }
  },
 
  mounted: function() {
    this.isBusy = true;
    
    this.state.project = "Standalone Journal";
    this.state.projectId = "";

    this.setBreadcrumb();

    this.fetchData();
    
    var today = this.$moment().format("YYYYMMDD"); 
    if (!this.date) {
      this.$router.push({name: 'StandaloneJournal', params: { id: this.journalId, date: today } }, () =>{} );
    }
  },

  activated: function() {
     
    this.tabIndex = 0;

    this.state.project = "Standalone Journal";
    this.state.projectId = "";

    this.setBreadcrumb();

    var today = this.$moment().format("YYYYMMDD"); 
    if (!this.date) {
      this.$router.push({name: 'StandaloneJournal', params: { id: this.journalId, date: today } }, () =>{} );
    };
  

  }
};
</script>

<style>

#journal {
  text-align: left;
  max-width: 800px;
  margin: 0 auto;
  
}

@media (max-width: 400px) {
    #journalview {
    display: none;
    }
}

</style>